export default "__VITE_ASSET__CpZ$0xEJ__"